$(document).ready(function () {
  $('.owl-carousel-usp').owlCarousel({
    loop: true,
    margin: 0,
    lazyLoad: true,
    responsiveClass: true,
    autoplayHoverPause: true,
    dots: false,
    responsive: {
      0: {
        items: 1,
        nav: true,
        dots: false,
      },
      600: {
        items: 2,
        nav: true,
      },
      1000: {
        items: 4,
        nav: true,
        autoplay: false,
        loop: true,
      },
    },
  });
});
